
import React, { useEffect, useState } from "react";
import axios from "axios";

const PackageCard = ({ pkg, onBook,isInCart,onRemove }) => {
  const [expanded, setExpanded] = useState(false);
  const savings = pkg.total - pkg.offerPrice;
  const discountPct = Math.round((savings / pkg.total) * 100);
  const preview = pkg.tests.slice(0, expanded ? pkg.tests.length : 4);
  return (
    <>
    <style>{CSS}</style>
    <div className="pkg-card">
      {/* Coloured header */}
      <div className="pkg-card-header" style={{ background: pkg.gradient }}>
        <div className="pkg-card-orb o1" />
        <div className="pkg-card-orb o2" />
        <div className="pkg-card-top-row">
          <span className="pkg-tier-badge" style={{ background: pkg.badgeBg, color: pkg.badgeColor }}>
            {pkg.icon} {pkg.tier}
          </span>
          <span className="pkg-disc-chip">{discountPct}% OFF</span>
        </div>
        <h3 className="pkg-card-name">{pkg.name}</h3>
        <p className="pkg-card-tagline">{pkg.tagline}</p>
        <div className="pkg-price-row">
          <span className="pkg-offer-price" style={{ color: pkg.accentColor }}>
            ₹{pkg.offerPrice.toLocaleString()}
          </span>
          <span className="pkg-mrp">₹{pkg.total.toLocaleString()}</span>
          <span className="pkg-save-chip">Save ₹{savings.toLocaleString()}</span>
        </div>
      </div>

      {/* Body */}
      <div className="pkg-card-body">
        <div className="pkg-tests-hdr">
          <span className="pkg-tests-lbl">🔬 Included Tests</span>
          <span className="pkg-tests-cnt" style={{ background: pkg.badgeBg, color: pkg.badgeColor }}>
            {pkg.tests.length}
          </span>
        </div>

        <div className="pkg-tests-list">
          {preview.map((t, i) => (
            <div key={i} className="pkg-test-row">
              <span className="pkg-test-dot" style={{ background: pkg.badgeColor }} />
              <span className="pkg-test-name">
                {t.name.length > 50 ? t.name.slice(0, 50) + "…" : t.name}
              </span>
            </div>
          ))}
        </div>

        {pkg.tests.length > 4 && (
          <button className="pkg-expand-btn" style={{ color: pkg.badgeColor }}
            onClick={() => setExpanded(!expanded)}>
            {expanded ? "▲ Show less" : `▼ +${pkg.tests.length - 4} more tests`}
          </button>
        )}

        {/* Footer pinned to bottom */}
        <div className="pkg-card-footer">
          <div className="pkg-footer-price">
            <span className="pkg-footer-lbl">Offer Price</span>
            <span className="pkg-footer-val" style={{ color: pkg.badgeColor }}>
              ₹{pkg.offerPrice.toLocaleString()}
            </span>
          </div>
          <button className="pkg-book-btn" style={{ background: pkg.gradient }}
           onClick={isInCart ? () => {const addedPkg = { id: pkg.id || pkg.pkg_id, test_name: pkg.name, category: "Package", mrp: pkg.total || pkg.mrp || pkg.offerPrice, non_membership: pkg.offerPrice, proposed_rate: pkg.offerPrice, price: pkg.offerPrice, is_package: true, pkg_id: pkg.pkg_id, tests: pkg.tests || [] };
            onRemove(addedPkg)} : () => {
            const addedPkg = { id: pkg.id || pkg.pkg_id, test_name: pkg.name, category: "Package", mrp: pkg.total || pkg.mrp || pkg.offerPrice, non_membership: pkg.offerPrice, proposed_rate: pkg.offerPrice, price: pkg.offerPrice, is_package: true, pkg_id: pkg.pkg_id, tests: pkg.tests || [] };
            onBook(addedPkg)}}>
           {isInCart ? "✕ Remove" : "+ Add to Cart"}
          </button>
          
        </div>
      </div>
    </div>
    </>
  );
  
};


export default PackageCard;
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@700;800;900&family=Nunito:wght@400;500;600;700;800&display=swap');

  /* ── Reset scoped to our page ── */
  .page-root *, .page-root *::before, .page-root *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .page-root {
    /* Desktop: offset by sidebar width so content starts after the sidebar */
    margin-left: 280px;
    width: calc(100% - 280px);
    overflow-x: hidden;
    min-height: 100vh;
    background: #EEF4F5;
    font-family: 'Nunito', sans-serif;
    color: #0F172A;
  }

  /* On mobile (≤ 899px) the sidebar is hidden, so remove the offset */
  @media (max-width: 899px) {
    .page-root {
      margin-left: 0;
      width: 100%;
    }
  }
  .pkg-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: clamp(14px, 2.2vw, 24px);
    align-items: stretch;
  }

  @media (max-width: 900px) {
    .pkg-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 580px) {
    .pkg-grid {
      grid-template-columns: 1fr;
    }
  }

  .pkg-card {
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 3px 14px rgba(0,0,0,0.07);
    display: flex;
    flex-direction: column;
    height: 100%;
    transition: transform 0.22s ease, box-shadow 0.22s ease;
  }
  .pkg-card:hover { transform:translateY(-5px); box-shadow:0 18px 44px rgba(0,0,0,0.13); }

  .pkg-card-header { padding:clamp(16px,2.5vw,22px); position:relative; overflow:hidden; flex-shrink:0; }
  .pkg-card-orb { position:absolute; border-radius:50%; pointer-events:none; }
  .o1 { top:-38px; right:-38px; width:125px; height:125px; background:rgba(255,255,255,0.10); }
  .o2 { bottom:-22px; left:-18px; width:80px;  height:80px;  background:rgba(255,255,255,0.07); }

  .pkg-card-top-row { display:flex; justify-content:space-between; align-items:center; margin-bottom:10px; position:relative; z-index:1; }
  .pkg-tier-badge { font-size:clamp(10px,1.4vw,12px); font-weight:800; padding:4px 11px; border-radius:50px; }
  .pkg-disc-chip  { background:#10B981; color:#fff; font-size:11px; font-weight:800; padding:4px 9px; border-radius:20px; }

  .pkg-card-name    { font-family:'Sora',sans-serif; font-size:clamp(14px,2.2vw,17px); font-weight:800; color:#fff; margin-bottom:4px; position:relative; z-index:1; line-height:1.3; }
  .pkg-card-tagline { font-size:clamp(11px,1.5vw,13px); color:rgba(255,255,255,0.72); line-height:1.6; margin-bottom:12px; position:relative; z-index:1; }

  .pkg-price-row { display:flex; align-items:center; gap:9px; flex-wrap:wrap; position:relative; z-index:1; }
  .pkg-offer-price { font-family:'Sora',sans-serif; font-size:clamp(19px,2.8vw,25px); font-weight:900; }
  .pkg-mrp       { font-size:13px; color:rgba(255,255,255,0.5); text-decoration:line-through; font-weight:600; }
  .pkg-save-chip  { background:rgba(16,185,129,0.25); border:1px solid rgba(16,185,129,0.5); color:#80ED99; font-size:11px; font-weight:800; padding:3px 9px; border-radius:20px; }

  /* card body: flex:1 takes remaining vertical space, footer stays at bottom */
  .pkg-card-body { padding:clamp(14px,2.5vw,20px); flex:1; display:flex; flex-direction:column; }

  .pkg-tests-hdr { display:flex; align-items:center; gap:7px; margin-bottom:10px; }
  .pkg-tests-lbl { font-size:11px; font-weight:700; color:#64748B; text-transform:uppercase; letter-spacing:0.5px; }
  .pkg-tests-cnt { font-size:11px; font-weight:800; padding:2px 7px; border-radius:50px; }

  /* flex:1 pushes footer down */
  .pkg-tests-list { flex:1; }
  .pkg-test-row  { display:flex; align-items:flex-start; gap:8px; margin-bottom:6px; }
  .pkg-test-dot  { width:7px; height:7px; border-radius:50%; flex-shrink:0; margin-top:5px; }
  .pkg-test-name { font-size:clamp(12px,1.6vw,13px); color:#374151; line-height:1.55; }

  .pkg-expand-btn { background:none; border:none; cursor:pointer; font-size:12px; font-weight:700; padding:3px 0; margin:4px 0 10px; text-decoration:underline; font-family:'Nunito',sans-serif; }

  /* margin-top:auto pins footer to bottom of card */
  .pkg-card-footer { display:flex; justify-content:space-between; align-items:center; gap:10px; padding-top:12px; border-top:1px solid #F1F5F9; flex-wrap:wrap; margin-top:auto; }
  .pkg-footer-price { display:flex; flex-direction:column; gap:2px; }
  .pkg-footer-lbl { font-size:11px; color:#94A3B8; font-weight:600; }
  .pkg-footer-val { font-family:'Sora',sans-serif; font-size:clamp(16px,2.3vw,20px); font-weight:900; line-height:1; }
  .pkg-book-btn { border:none; border-radius:10px; padding:clamp(9px,1.6vw,12px) clamp(14px,2.2vw,20px); font-size:clamp(12px,1.6vw,14px); font-weight:800; color:#fff; cursor:pointer; white-space:nowrap; font-family:'Nunito',sans-serif; transition:filter 0.2s, transform 0.15s; box-shadow:0 3px 10px rgba(0,0,0,0.18); }
  .pkg-book-btn:hover { filter:brightness(1.1); transform:translateY(-2px); }



  .mo-hero { padding:clamp(18px,3.5vw,28px); position:relative; overflow:hidden; }
  .mo-orb1 { position:absolute; top:-45px; right:-45px; width:160px; height:160px; border-radius:50%; background:rgba(255,255,255,0.10); pointer-events:none; }
  .mo-orb2 { position:absolute; bottom:-28px; left:-18px; width:105px; height:105px; border-radius:50%; background:rgba(255,255,255,0.07); pointer-events:none; }
  .mo-close { position:absolute; top:12px; right:12px; background:rgba(255,255,255,0.2); border:none; color:#fff; width:30px; height:30px; border-radius:50%; cursor:pointer; font-size:13px; font-weight:700; display:flex; align-items:center; justify-content:center; z-index:2; }
  .mo-close:hover { background:rgba(255,255,255,0.35); }

  .mo-hero-inner { display:flex; align-items:flex-start; gap:14px; position:relative; z-index:1; }
  .mo-pkg-icon  { font-size:clamp(32px,5vw,44px); flex-shrink:0; }
  .mo-pkg-info  { flex:1; min-width:0; }
  .mo-pkg-tier  { font-size:11px; font-weight:800; text-transform:uppercase; letter-spacing:0.8px; margin-bottom:3px; }
  .mo-pkg-name  { font-family:'Sora',sans-serif; font-size:clamp(14px,2.8vw,18px); font-weight:800; color:#fff; margin-bottom:7px; line-height:1.25; }
  .mo-pkg-pricing { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
  .mo-offer     { font-family:'Sora',sans-serif; font-size:clamp(17px,3.5vw,22px); font-weight:900; }
  .mo-strike    { font-size:13px; color:rgba(255,255,255,0.5); text-decoration:line-through; font-weight:600; }
  .mo-save-chip { background:rgba(16,185,129,0.25); border:1px solid rgba(16,185,129,0.5); color:#80ED99; font-size:11px; font-weight:800; padding:3px 9px; border-radius:20px; }

  
  /* ── Responsive extras ── */
  @media (max-width: 600px) {
    .banner-stat { width:100%; display:flex; align-items:center; gap:10px; padding:10px 14px; }
    .stat-num { font-size:1.8rem; }
    .controls-inner { flex-direction:column; align-items:stretch; }
    .tier-row { overflow-x:auto; flex-wrap:nowrap; padding-bottom:4px; -webkit-overflow-scrolling:touch; }
    .tier-btn { flex-shrink:0; }
    .step-lbl { display:none; }
    .mo-nav { flex-direction:column-reverse; }
    .mo-next-btn, .mo-primary-btn { min-width:unset; }
    .pkg-card-footer { flex-direction:column; align-items:stretch; }
    .pkg-book-btn { width:100%; text-align:center; }
  }
  @media (max-width: 380px) {
    .pay-opt { flex-wrap:wrap; }
    .mo-pkg-pricing { flex-direction:column; align-items:flex-start; }
  }
`;